var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "PolarisVue-FadeTransition",
      "enter-active-class": "PolarisVue-FadeTransition--show",
      "leave-active-class": "PolarisVue-FadeTransition--show",
      "enter-class": "PolarisVue-FadeTransition--hide",
      "leave-to-class": "PolarisVue-FadeTransition--hide"
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7144095b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7144095b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/transitions/FadeTransition.vue
// module id = 364
// module chunks = 0